import React, { useState } from 'react';
import { ThumbsUpIcon, ThumbsDownIcon } from './Icons';

type FeedbackType = 'like' | 'dislike' | null;

interface MessageFeedbackProps {
  messageId: string;
  onFeedback?: (messageId: string, feedback: FeedbackType) => void;
}

const MessageFeedback: React.FC<MessageFeedbackProps> = ({ messageId, onFeedback }) => {
  const [feedback, setFeedback] = useState<FeedbackType>(null);
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);

  const handleFeedback = (type: FeedbackType) => {
    const newFeedback = feedback === type ? null : type;
    setFeedback(newFeedback);
    onFeedback?.(messageId, newFeedback);
  };

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '4px',
  };

  const buttonStyle = (type: 'like' | 'dislike'): React.CSSProperties => {
    const isActive = feedback === type;
    const isHovered = hoveredButton === type;
    const activeColor = type === 'like' ? '#33AA40' : '#FF5656';

    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '28px',
      height: '28px',
      borderRadius: '4px',
      border: 'none',
      background: isActive ? `${activeColor}20` : isHovered ? 'rgba(0,0,0,0.05)' : 'transparent',
      cursor: 'pointer',
      padding: '4px',
      color: isActive ? activeColor : '#999999',
      transition: 'all 0.15s ease',
    };
  };

  return (
    <div style={containerStyle}>
      <button
        style={buttonStyle('like')}
        onClick={() => handleFeedback('like')}
        onMouseEnter={() => setHoveredButton('like')}
        onMouseLeave={() => setHoveredButton(null)}
        title="Helpful"
      >
        <ThumbsUpIcon size={14} color={feedback === 'like' ? '#33AA40' : '#999999'} />
      </button>
      <button
        style={buttonStyle('dislike')}
        onClick={() => handleFeedback('dislike')}
        onMouseEnter={() => setHoveredButton('dislike')}
        onMouseLeave={() => setHoveredButton(null)}
        title="Not helpful"
      >
        <ThumbsDownIcon size={14} color={feedback === 'dislike' ? '#FF5656' : '#999999'} />
      </button>
    </div>
  );
};

export default MessageFeedback;
